<template>
	<div :class="`box box--${alignment} box--${type}`">
		<slot />
	</div>
</template>

<script>
export default {
	props: {
		alignment: {
			type: String,
			required: false,
			default: 'left',
		},
		type: {
			type: String,
			required: false,
			default: 'vertical',
		},
	},
};
</script>

<style lang="scss" scoped src="./box.scss" />
